import { Backdrop, Box, IconButton } from "@mui/material";
import { styled } from '@mui/material/styles';
import React, { useState, useEffect } from "react";
import { CloseCircle } from "../../../assets/images/closeCircle";

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: -54,
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 11,
}));

const VideoOverlay = ({ videoId, isOpen, onClose }) => {
  const [overlaySize, setOverlaySize] = useState({
    width: "0px",
    height: "0px",
  });

  useEffect(() => {
    const updateOverlaySize = () => {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      let width, height;

      // Calculate the width and height while maintaining the 16:9 ratio
      if (screenWidth / screenHeight > 16 / 9) {
        height = screenHeight * 0.8;
        width = height * (16 / 9);
      } else {
        width = screenWidth * 0.8;
        height = width * (9 / 16);
      }

      setOverlaySize({ width: `${width}px`, height: `${height}px` });
    };

    updateOverlaySize();
    window.addEventListener("resize", updateOverlaySize);

    return () => window.removeEventListener("resize", updateOverlaySize);
  }, []);

  return (
    <Backdrop
      open={isOpen}
      onClick={onClose}
      sx={{ color: "#fff", zIndex: 1 }}
      style={{ zIndex: 11 }}
    >
      <Box
        sx={{
          position: "relative",
          bgcolor: "background.paper",
          borderRadius: 1,
          boxShadow: 24,
          width: overlaySize.width, // Dynamic width
          height: overlaySize.height, // Dynamic height
        }}
      >
        <CloseButton onClick={onClose}>
          <CloseCircle />
        </CloseButton>
        <Box sx={{ overflow: "hidden", width: "100%", height: "100%" }}>
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            style={{ position: "absolute", top: 0, left: 0 }}
          />
        </Box>
      </Box>
    </Backdrop>
  );
};

export default VideoOverlay;
